var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/helpers/extends", "react", "prop-types", "./SingleLineSlider.css", "../../UI/Icon/ArrowLeft", "../../UI/Icon/ArrowRight", "../../UI/Icon/IconSvg"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/helpers/extends"), require("react"), require("prop-types"), require("./SingleLineSlider.css"), require("../../UI/Icon/ArrowLeft"), require("../../UI/Icon/ArrowRight"), require("../../UI/Icon/IconSvg"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global._extends, global.react, global.propTypes, global.SingleLineSlider, global.ArrowLeft, global.ArrowRight, global.IconSvg);
    global.Arrows = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _extends2, _react, _propTypes, _SingleLineSlider, _ArrowLeft, _ArrowRight, _IconSvg) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.PrevArrow = _exports.NextArrow = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _ArrowLeft = _interopRequireDefault(_ArrowLeft);
  _ArrowRight = _interopRequireDefault(_ArrowRight);
  _IconSvg = _interopRequireDefault(_IconSvg);

  var LoadingButton = function LoadingButton(props) {
    return /*#__PURE__*/_react.default.createElement(_IconSvg.default, (0, _extends2.default)({
      name: "arte-icon--loading"
    }, props));
  };

  var NextArrow = function NextArrow(_ref) {
    var color = _ref.color,
        loading = _ref.loading,
        onClick = _ref.onClick,
        size = _ref.size,
        stateClass = _ref.stateClass,
        theme = _ref.theme,
        touchDevice = _ref.touchDevice;

    var Icon = function Icon() {
      return theme === 'concert' ? /*#__PURE__*/_react.default.createElement(_IconSvg.default, {
        name: "arte-icon--up2",
        color: color,
        size: size
      }) : /*#__PURE__*/_react.default.createElement(_ArrowRight.default, {
        color: color,
        size: size
      });
    };

    return /*#__PURE__*/_react.default.createElement(_SingleLineSlider.StyledArrowNext, {
      "aria-hidden": true,
      className: stateClass,
      onClick: onClick,
      tabIndex: "-1",
      touchDevice: touchDevice,
      loading: loading.toString(),
      themeName: theme
    }, loading ? /*#__PURE__*/_react.default.createElement(LoadingButton, {
      color: color,
      size: size
    }) : /*#__PURE__*/_react.default.createElement(Icon, null));
  };

  _exports.NextArrow = NextArrow;
  NextArrow.propTypes = {
    loading: _propTypes.default.bool,
    color: _propTypes.default.string,
    onClick: _propTypes.default.func,
    size: _propTypes.default.shape(),
    stateClass: _propTypes.default.string,
    theme: _propTypes.default.string,
    // name of the theme, not the theme object
    touchDevice: _propTypes.default.bool
  };
  NextArrow.defaultProps = {
    loading: false
  };

  var PrevArrow = function PrevArrow(_ref2) {
    var color = _ref2.color,
        onClick = _ref2.onClick,
        size = _ref2.size,
        stateClass = _ref2.stateClass,
        theme = _ref2.theme,
        touchDevice = _ref2.touchDevice;

    var Icon = function Icon() {
      return theme === 'concert' ? /*#__PURE__*/_react.default.createElement(_IconSvg.default, {
        name: "arte-icon--up2",
        color: color,
        size: size
      }) : /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, {
        color: color,
        size: size
      });
    };

    return /*#__PURE__*/_react.default.createElement(_SingleLineSlider.StyledArrowPrev, {
      "aria-hidden": true,
      className: stateClass,
      onClick: onClick,
      tabIndex: "-1",
      touchDevice: touchDevice,
      themeName: theme
    }, /*#__PURE__*/_react.default.createElement(Icon, null));
  };

  _exports.PrevArrow = PrevArrow;
  PrevArrow.propTypes = {
    color: _propTypes.default.string,
    onClick: _propTypes.default.func,
    size: _propTypes.default.shape(),
    stateClass: _propTypes.default.string,
    theme: _propTypes.default.string,
    // name of the theme, not the theme object
    touchDevice: _propTypes.default.bool
  };
});